<template>
  <div class="modal">
    <h1 id="header">You're an alienzombie.</h1>
    <p>
      In order to survive on Earth, you have to pretend to be a human on this
      planet. You took over the body of a nearby hooman, but the trouble is,
      their best friend showed up!
    </p>
    <p>
      They look suspicious. Answer the questions right to make sure identity is
      kept secret!
    </p>
    <slot></slot>
  </div>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped></style>
